module.exports = __webpack_public_path__ + "img/badge-type-a.071d0a16.svg";